import { render, staticRenderFns } from "./delete_modal.vue?vue&type=template&id=f99e5c28&scoped=true&lang=html&"
import script from "./delete_modal.vue?vue&type=script&lang=js&"
export * from "./delete_modal.vue?vue&type=script&lang=js&"
import style0 from "./delete_modal.vue?vue&type=style&index=0&id=f99e5c28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99e5c28",
  null
  
)

export default component.exports